import { useState } from "react";
import { api, type UserView } from "../api";
import { Overlay } from "../ui";
import { ResultScreen } from "./Result";

interface Props {
  user: UserView;
  onClose: () => void;
  onPaywall: () => void;
}

/** Натальная карта: сначала короткая форма (город + время рождения, не сохраняются в профиле), затем обычный разбор. */
export function Natal({ user, onClose, onPaywall }: Props) {
  const [city, setCity] = useState("");
  const [hour, setHour] = useState("");
  const [minute, setMinute] = useState("");
  const [submitted, setSubmitted] = useState(false);

  if (submitted && city.trim()) {
    const query: Record<string, string> = { natalCity: city.trim() };
    if (hour.trim() !== "" && minute.trim() !== "") {
      query.natalHour = hour.trim();
      query.natalMinute = minute.trim();
    }
    return (
      <ResultScreen
        title="Натальная карта"
        moduleId="natal"
        load={() => api.reading("natal", query)}
        user={user}
        favorite={null}
        onFavorite={() => undefined}
        onClose={onClose}
        onPaywall={onPaywall}
        aiExpandEnabled={false}
        aiReportEnabled={false}
      />
    );
  }

  return (
    <Overlay title="Натальная карта" onClose={onClose} tone="light">
      <div className="sheetbody">
        <div className="card">
          <h3>Где и когда ты родился</h3>
          <p className="sub">Укажи город рождения — так точнее определим расположение планет. Время рождения не обязательно, но без него не рассчитаем асцендент и дома.</p>
          <label className="field">
            <span>Город рождения</span>
            <input value={city} onChange={(e) => setCity(e.target.value)} placeholder="Например, Минск" />
          </label>
          <div style={{ display: "flex", gap: 8 }}>
            <label className="field" style={{ flex: 1 }}>
              <span>Час (0-23)</span>
              <input value={hour} onChange={(e) => setHour(e.target.value)} placeholder="Необязательно" inputMode="numeric" />
            </label>
            <label className="field" style={{ flex: 1 }}>
              <span>Минута (0-59)</span>
              <input value={minute} onChange={(e) => setMinute(e.target.value)} placeholder="Необязательно" inputMode="numeric" />
            </label>
          </div>
          <button className="primary" style={{ width: "100%", marginTop: 12 }} disabled={!city.trim()} onClick={() => setSubmitted(true)}>
            Построить карту
          </button>
        </div>
      </div>
    </Overlay>
  );
}
